export const SESSION_STORAGE_DRAFT_KEY = "ticket_drafts";
export const NEW_TICKET_TEMP_ID = "new_ticket";
